import TRUCKLANE_MINIMUM_MODE from '../../../enums/trucklane-minimum-mode';

export const labels = {
  [TRUCKLANE_MINIMUM_MODE.TOTAL_REVENUE]: 'Gross Revenue',
  [TRUCKLANE_MINIMUM_MODE.NET_REVENUE]: 'Net Revenue',
};

const emptyTruckTypeMinimum = () => ({
  dry: 0,
  refrigerated: 0,
  frozen: 0,
});

export const initializeStateFromDB = (trucklaneMinimums) => {
  if (!trucklaneMinimums) {
    return {
      mode: TRUCKLANE_MINIMUM_MODE.TOTAL_REVENUE,
      deliveryRevenue: emptyTruckTypeMinimum(),
      pickupRevenue: emptyTruckTypeMinimum(),
      deliveryWeight: emptyTruckTypeMinimum(),
      pickupWeight: emptyTruckTypeMinimum(),
      deliveryPallets: emptyTruckTypeMinimum(),
      pickupPallets: emptyTruckTypeMinimum(),
    };
  }
  const { deliveryRevenue, pickupRevenue, deliveryWeight, pickupWeight, deliveryPallets, pickupPallets } = trucklaneMinimums;
  return {
    mode: trucklaneMinimums.mode || null,
    deliveryRevenue: {
      dry: deliveryRevenue.dry || 0,
      refrigerated: deliveryRevenue.refrigerated || 0,
      frozen: deliveryRevenue.frozen || 0,
    },
    pickupRevenue: {
      dry: pickupRevenue.dry || 0,
      refrigerated: pickupRevenue.refrigerated || 0,
      frozen: pickupRevenue.frozen || 0,
    },
    deliveryWeight: {
      dry: deliveryWeight.dry || 0,
      refrigerated: deliveryWeight.refrigerated || 0,
      frozen: deliveryWeight.frozen || 0,
    },
    pickupWeight: {
      dry: pickupWeight.dry || 0,
      refrigerated: pickupWeight.refrigerated || 0,
      frozen: pickupWeight.frozen || 0,
    },
    deliveryPallets: {
      dry: deliveryPallets.dry || 0,
      refrigerated: deliveryPallets.refrigerated || 0,
      frozen: deliveryPallets.frozen || 0,
    },
    pickupPallets: {
      dry: pickupPallets.dry || 0,
      refrigerated: pickupPallets.refrigerated || 0,
      frozen: pickupPallets.frozen || 0,
    },
  };
};

export const minimumReducer = (state, action) => {
  if (action.type === 'initializeState') {
    initializeStateFromDB(action.dbState);
  }
  const { mode, deliveryRevenue, pickupRevenue, deliveryWeight, pickupWeight, deliveryPallets, pickupPallets } = state;
  const newState = {
    mode,
    deliveryRevenue: { ...deliveryRevenue },
    pickupRevenue: { ...pickupRevenue },
    deliveryWeight: { ...deliveryWeight },
    pickupWeight: { ...pickupWeight },
    deliveryPallets: { ...deliveryPallets },
    pickupPallets: { ...pickupPallets },
  };
  if (action.type === 'setMinimum') newState[action.term][action.truckType] = action.value;
  if (action.type === 'setMode') newState.mode = action.value;
  return newState;
};
